export const AUTH_TOKEN = "nakama_auth_token";
export const AUTH_PROFILE = "nakama_auth_profile";
